import { 
    FETCH_ERRORS_FILTER,  
    NEW_ERROR, 
    EDIT_ERROR,
    DELETE_ERROR,
    CHANGE_ERROR_MASTER_DEGREE,
    URL 
} from './types';

export const fetchErrorsFilter = (token, filter) => dispatch => {
    fetch(URL + 'api2/errorsfilter/?' + filter, {
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        })
    })
    .then(res=>res.json())
    .then(errors=>
        dispatch({
            type: FETCH_ERRORS_FILTER,
            payload: errors
        }) 
    )
}

export const newError = (token, errorData) => dispatch => {
    fetch(URL + 'api2/errors/', {
        method: 'POST',
        headers: new Headers({
            'Authorization': 'JWT ' + token,
        }),
        body: errorData
    })
    .then(res=>res.json())
    .then(error=>
        dispatch({
            type: NEW_ERROR,
            payload: error
        })
    );
}

export const editError = (token, errorData, id) => dispatch => {
    fetch(URL + 'api2/error/' + id + '/', {
        method: 'PATCH',
        headers: new Headers({
            'Authorization': 'JWT ' + token,
        }),
        body: errorData
    })
    .then(res=>res.json())
    .then(error=>
        dispatch({
            type: EDIT_ERROR,
            payload: error
        })
    );
}

export const changeErrorMasterDegree = (token, id, newRating) => dispatch => {
    console.log('on change error master degree action.')
    fetch(URL + 'api2/error/' + id + '/', {
        method: 'PATCH',
        headers: new Headers({
            'Authorization': 'JWT ' + token,
            'content-type': 'application/json'
        }),
        body: JSON.stringify({"master_degree":newRating})
    })
    .then(res=>res.json())
    .then(error=>
        dispatch({
            type: CHANGE_ERROR_MASTER_DEGREE,
            payload: error
        })
    );
}

export const deleteError = (token, id) => dispatch => {
    fetch(URL + 'api2/error/' + id + '/',{
        method: 'DELETE',
        headers: new Headers({
            'Authorization': 'JWT ' + token,
        })
    })
    .then()
    .then(error=>
        dispatch({
            type: DELETE_ERROR,
            payload: {}
        })
    )
}


// WEBPACK FOOTER //
// ./src/actions/errorActions.js